export const moon = () => (
  <path
    d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
